





















import { Component, Vue, Prop } from 'vue-property-decorator'
import { State, Getter, Mutation } from 'vuex-class'
import _get from 'lodash/get'
import { GuidePrice } from '@/types'
import { stringToCurrency } from '@/utils/numeric.util'

@Component({})
export default class GuidePricesTable extends Vue {
  @Mutation('setActiveGuidePrice', { namespace: 'books' }) private setActiveGuidePrice: any
  @Mutation('setAddedOfferItem', { namespace: 'offerCarts' }) private setAddedOfferItem: any

  @Prop({ required: true, default: [] })
  private readonly guidePrices: GuidePrice[] | undefined

  private mounted(): void {}

  private destroyed(): void {}

  private getCondition(guidePrice): string {
    return _get(guidePrice, ['condition', 'name']) || ''
  }

  private getCurrency(price): string {
    const temp = stringToCurrency(price)
    return `$${temp || '0.00'}`
  }

  private onClickRow(guidePrice) {
    this.setAddedOfferItem(false)
    this.setActiveGuidePrice(guidePrice)
  }
}
